module.exports = __webpack_public_path__ + "images/4d1e55f2.png";